import { BRANCH_ID } from '__test-utils__/ids'

export const MockedHardResetBranchResponses: Record<string, number> = {
  [BRANCH_ID]: 204,
  'test-branch': 204,
  500: 500
}
